import React, { useEffect, useState } from "react";
import axios from "axios";
import { Base_URL, tempURl } from "../url";
import { useLocation, useNavigate } from "react-router-dom";

const Token = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [tokenData, setTokenData] = useState("");

  useEffect(() => {
    const pathParts = location.pathname.split("token=");
    console.log(pathParts, "pathParts");
    //  return
    if (pathParts.length > 1) {
      const extractedToken = pathParts[1];
      setTokenData(extractedToken);
      console.log("Extracted Token:", extractedToken);
    }
  }, [location]);

  useEffect(() => {
    if (tokenData) {
      console.log("Running API call with token:", tokenData);
      axios
        .get(`${Base_URL}/auth/userinfo?token=${tokenData}`)
        .then((response) => {
          console.log("Response from token API:", response);
          //   localStorage.setItem('userData', JSON.stringify(response?.data));

          //    localStorage.setItem("token", response.data.token);
          localStorage.setItem("username", response.data.userResponse.username);
          localStorage.setItem(
            "userDetails",
            JSON.stringify(response.data.userResponse)
          );
          localStorage.setItem("isMicrosoftUser", "false");
          // You can store this data in another state if needed
          // return
          setTimeout(() => {
            navigate("/home");
            window.location.reload("/home");
          }, 100);
        })
        .catch((error) => {
          console.error("API error:", error);
        });
    }
  }, [tokenData]);

  return (
    <div>
      <h1>Loading...</h1>
    </div>
  );
};

export default Token;
